import React from 'react';
import { Card, Table, Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSort, FaSortUp, FaSortDown, FaEye, FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';

const GenericTable = ({
  items,
  columns,
  onSort,
  onEdit,
  onView,
  onDelete,
  toggleStatus,
  sortField,
  sortDirection,
  emptyIcon: EmptyIcon,
  emptyTitle = 'No Items Found'
}) => {
  const getSortIcon = (field) => {
    if (sortField !== field) return <FaSort className="text-muted opacity-50" />;
    return sortDirection === 'asc' ? <FaSortUp className="text-primary" /> : <FaSortDown className="text-primary" />;
  };

  return (
    <Card className="border-0 shadow-sm card-hover-effect">
      <Card.Body className="p-0">
        <Table responsive hover className="align-middle mb-0">
          <thead className="table-light">
            <tr>
              {columns.map(column => (
                <th
                  key={column.key}
                  className={`py-3 px-3 ${column.sortable ? 'cursor-pointer user-select-none' : ''} ${column.align === 'center' ? 'text-center' : ''}`}
                  onClick={column.sortable ? () => onSort(column.key) : undefined}
                >
                  {column.label}
                  {column.sortable && getSortIcon(column.key)}
                </th>
              ))}
              <th className="py-3 px-3 text-center">Status</th>
              <th className="py-3 px-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={columns.length + 2} className="text-center py-5 text-muted">
                  <EmptyIcon size={48} className="mb-3 opacity-25" />
                  <h4>{emptyTitle}</h4>
                  <p>Try adjusting your search or filters.</p>
                </td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  {columns.map(column => (
                    <td key={column.key} className={`px-3 ${column.align === 'center' ? 'text-center' : ''}`}>
                      {column.render ? column.render(item) : item[column.key]}
                    </td>
                  ))}
                  <td className="text-center">
                    <Badge
                      pill
                      bg={item.exIsActive ? 'success-subtle' : 'secondary-subtle'}
                      text={item.exIsActive ? 'success-emphasis' : 'secondary-emphasis'}
                      className="cursor-pointer status-badge"
                      onClick={() => toggleStatus(item)}
                    >
                      {item.exIsActive ? (
                        <><FaCheck className="me-1" />Active</>
                      ) : (
                        <><FaTimes className="me-1" />Inactive</>
                      )}
                    </Badge>
                  </td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>}>
                        <Button variant="outline-info" size="sm" onClick={() => onView(item)}>
                          <FaEye />
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                        <Button variant="outline-primary" size="sm" onClick={() => onEdit(item)}>
                          <FaEdit />
                        </Button>
                      </OverlayTrigger>
                      {onDelete && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                          <Button variant="outline-danger" size="sm" onClick={() => onDelete(item)}>
                            <FaTrash />
                          </Button>
                        </OverlayTrigger>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default GenericTable;